import { CommonFragments } from './common.fragments';

export class PurchasesAndSalesFragments {
  /*
   * Fragment for the purchases and sales items
   */
  private static readonly purchasesAndSalesItemFragment = `
    percentTotalNetAssets
    previousQuarterChange
    name
    previousQuarterPercentTotalNetAssets
    sectorName
    rank
  `;

  /**
   * GraphQL Fragment for the Purchases and Sales Exhibit
   */
  public static readonly purchasesAndSalesFragment = `
    purchaseSalesExhibit {
      asOfDate
      availablePriorDates
      purchasesList {
        ${PurchasesAndSalesFragments.purchasesAndSalesItemFragment}
      }
      salesList {
        ${PurchasesAndSalesFragments.purchasesAndSalesItemFragment}
      }
      ${CommonFragments.disclaimerFragment}
    }
  `;
}
